import {useEffect} from 'react'
import {useLocalObservable} from 'mobx-react'
import {useProductStore} from './useStore'

export const useProductDetail = (productId: string) => {
  const productStore = useProductStore()

  const self = useLocalObservable(() => ({
    productId,

    /** The full, observable product object */
    get product() {
      return productStore.productsById[productId]
    },

    updateProduct(id: string) {
      this.productId = id
      productStore.fetchProducts([id], false)
    },
  }))

  /**
   * Keep our observable in sync with incoming `productId` arg.
   */
  useEffect(() => {
    self.updateProduct(productId)
  }, [productId])

  return self
}
